import { ArrowDownLeft, ArrowUpRight, CheckCheck, Paperclip, Download } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { openDocument } from "@/lib/api";

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString() : "");

export const ConversationLogs = ({ requests }) => {
  const replied = requests.filter((r) => r.outbound_message);
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-lg border border-white/10 bg-[#111723]">
      <div className="border-b border-white/10 p-4">
        <h3 className="font-display text-lg font-bold text-slate-50">Conversation Audit Log</h3>
        <p className="mt-0.5 text-xs text-slate-400">Full inbound query &rarr; outbound reply trail</p>
      </div>
      <div className="flex-1 space-y-4 overflow-y-auto p-4" data-testid="conversation-logs">
        {replied.length === 0 && (
          <div className="flex h-32 items-center justify-center">
            <p className="text-sm text-slate-500">No conversations logged yet.</p>
          </div>
        )}
        {replied.map((r) => (
          <div key={r.id} data-testid={`log-${r.id}`} className="rounded-lg border border-white/10 bg-[#0B0F17] p-3 fade-up">
            <div className="flex items-center justify-between">
              <span className="font-mono-data text-xs font-semibold text-blue-400">{r.case_number}</span>
              <div className="flex items-center gap-2">
                {r.source === "external_registry" && (
                  <span className="rounded bg-blue-500/15 px-1.5 py-0.5 text-[10px] uppercase text-blue-400">eCourts</span>
                )}
                {r.delivery_channel === "simulated" && (
                  <span className="rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] uppercase text-amber-400">simulated</span>
                )}
                <StatusBadge status={r.status} />
              </div>
            </div>
            <div className="mt-1 text-[11px] text-slate-500">
              {r.lawyer_name || "Lawyer"} · <span className="font-mono-data">{r.from_number}</span> · {fmtTime(r.created_at)}
            </div>
            <div className="mt-3 space-y-2">
              <div className="flex gap-2">
                <ArrowDownLeft className="mt-0.5 h-3.5 w-3.5 shrink-0 text-blue-400" />
                <p className="text-xs text-slate-300">{r.inbound_message}</p>
              </div>
              <div className="flex gap-2">
                <ArrowUpRight className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-400" />
                <p className="whitespace-pre-wrap rounded bg-[#111723] p-2 text-xs text-slate-300">{r.outbound_message}</p>
              </div>
            </div>
            {r.delivery_channel === "whatsapp" && (
              <div className={`mt-2 flex items-center gap-1 text-[10px] ${r.delivered ? "text-emerald-400" : "text-amber-400"}`}>
                <CheckCheck className="h-3 w-3" /> WhatsApp: {r.delivery_status || (r.delivered ? "delivered" : "queued")}{r.delivery_error ? ` (err ${r.delivery_error})` : ""}
              </div>
            )}
            {r.attachments?.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1.5">
                {r.attachments.map((a, j) => (
                  a.case_id && a.doc_id ? (
                    <button
                      key={j}
                      onClick={() => openDocument(a.case_id, a.doc_id)}
                      data-testid={`log-attachment-${j}`}
                      className="flex items-center gap-1 rounded bg-slate-800 px-1.5 py-0.5 text-[10px] text-emerald-300 transition-colors duration-200 hover:bg-slate-700"
                    >
                      <Paperclip className="h-3 w-3" /> {a.filename}
                      <Download className="h-3 w-3" />
                    </button>
                  ) : (
                    <span key={j} data-testid={`log-attachment-${j}`} className="flex items-center gap-1 rounded bg-slate-800 px-1.5 py-0.5 text-[10px] text-slate-300">
                      <Paperclip className="h-3 w-3" /> {a.filename}
                    </span>
                  )
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
